webpackJsonp([111636666260255],{

/***/ 43:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 34:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(43);
	
	var _gatsbyLink = __webpack_require__(17);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactHelmet = __webpack_require__(4);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _ButtonSquare = __webpack_require__(11);
	
	var _logo_comdeslezards = __webpack_require__(47);
	
	var _logo_comdeslezards2 = _interopRequireDefault(_logo_comdeslezards);
	
	var _TechnologiesBlock = __webpack_require__(51);
	
	var _TechnologiesBlock2 = _interopRequireDefault(_TechnologiesBlock);
	
	var _reactMarkdown = __webpack_require__(69);
	
	var _reactMarkdown2 = _interopRequireDefault(_reactMarkdown);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ServiceView = function ServiceView(props) {
	  var markdown = '# This is a header\n\nAnd this is a paragraph';
	  var picture = props.picture,
	      title = props.title,
	      description = props.description,
	      technologies = props.technologies;
	
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(_reactHelmet2.default, { title: title + ' - Com des L\xE9zards' }),
	    _react2.default.createElement(
	      _gatsbyLink2.default,
	      { to: '/' },
	      _react2.default.createElement('img', {
	        className: 'logo',
	        src: _logo_comdeslezards2.default,
	        alt: 'logo comdesl\xE9zards com des l\xE9zards' })
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'serviceview_returnbutton' },
	      _react2.default.createElement(_ButtonSquare.ButtonReturn, null)
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'serviceview_container' },
	      _react2.default.createElement(
	        'div',
	        { className: 'serviceview_picture' },
	        _react2.default.createElement('img', { src: picture, alt: '' })
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'serviceview_infos' },
	        _react2.default.createElement(
	          'h1',
	          null,
	          title
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'serviceview_infos_description' },
	          _react2.default.createElement(_reactMarkdown2.default, { source: description })
	        ),
	        _react2.default.createElement(
	          'div',
	          { style: { display: 'flex', justifyContent: 'center' } },
	          _react2.default.createElement(
	            _ButtonSquare.ButtonText,
	            { link: '#contact' },
	            'Nous contacter'
	          )
	        ),
	        _react2.default.createElement('div', { className: 'delimiter' }),
	        _react2.default.createElement(_TechnologiesBlock2.default, { technologies: technologies })
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'serviceview_scroll_button' },
	      _react2.default.createElement(_ButtonSquare.ButtonScroll, { link: '#r\xE9f\xE9rences' })
	    )
	  );
	};
	
	ServiceView.propTypes = {
	  picture: _propTypes2.default.string.isRequired,
	  title: _propTypes2.default.string.isRequired,
	  description: _propTypes2.default.string.isRequired,
	  technologies: _propTypes2.default.arrayOf(_propTypes2.default.string).isRequired
	};
	
	exports.default = ServiceView;
	module.exports = exports['default'];

/***/ }),

/***/ 47:
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 35:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _ServiceView = __webpack_require__(34);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ServiceView).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ 571:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/picture_showcase.d97ce5c4.png";

/***/ }),

/***/ 204:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(4);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _View = __webpack_require__(7);
	
	var _View2 = _interopRequireDefault(_View);
	
	var _ServiceView = __webpack_require__(35);
	
	var _ServiceView2 = _interopRequireDefault(_ServiceView);
	
	var _IndexSecondView = __webpack_require__(50);
	
	var _IndexSecondView2 = _interopRequireDefault(_IndexSecondView);
	
	var _ContactView = __webpack_require__(5);
	
	var _ContactView2 = _interopRequireDefault(_ContactView);
	
	var _FooterView = __webpack_require__(6);
	
	var _FooterView2 = _interopRequireDefault(_FooterView);
	
	var _picture_showcase = __webpack_require__(571);
	
	var _picture_showcase2 = _interopRequireDefault(_picture_showcase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var title = 'Sites vitrine';
	var description = '\n\n\nUn site internet est la base de toute **communication digitale**. C\u2019est le seul m\xE9dia web sur lequel vous avez un **contr\xF4le total**. Contrairement aux autres sites par lesquels vous communiquez peut \xEAtre d\xE9j\xE0 comme les r\xE9seaux sociaux ou les annuaires/comparateurs comme Booking, TripAdvisor et bien d\'autres. C\u2019est pour cela que nous ne nous contentons pas de personnaliser des solutions d\xE9j\xE0 existantes mais que nous **fa\xE7onnons votre site web de z\xE9ro**. Quoi de mieux pour communiquer vos valeurs qu\u2019un site internet **totalement \xE0 votre image**.\n\n### Comment produisons-nous pour vous ce fameux site internet vitrine id\xE9al :\n-   **Un entretien** pendant lequel nous en apprenons plus sur vous, votre activit\xE9 et vos besoins.\n-   **Une maquette graphique** par un graphiste exp\xE9riment\xE9 pour un site web design et sur-mesure.\n-   Apr\xE8s votre feu vert sur la maquette, nous d\xE9veloppons le site vitrine avec des **technologies modernes et performantes** que ce soit pour une navigation rapide ou pour un bon r\xE9f\xE9rencement pour une pr\xE9sence en ligne accrue sur les moteurs de recherche.\n-   Le d\xE9veloppement de votre site termin\xE9, nous l\u2019h\xE9bergeons chez un gros **h\xE9bergeur fran\xE7ais** parce qu\u2019on est un peu chauvain, mais aussi parce que c\u2019est un des meilleurs mondiaux et qu\u2019un site internet en ligne en tout temps c\u2019est mieux.\n-   On vous fournis une **interface web** vous permettant de modifier, ajouter ou supprimer du contenu \xE0 tout instant, un **CMS** (Content Management System) pour les connaisseurs. Ce CMS n\u2019est pas un vulgaire Wordpress mais une interface que nous avons configur\xE9 pour vous pour que g\xE9rer le contenu de votre site web soit une t\xE2che simple et rapide.\n-   Votre tout nouveau site vitrine est en ligne mais nous ne vous quittons pas l\xE0. En plus d\u2019assurer la maintenance de votre nouveau site internet, nous avons \xE0 coeur d\u2019avoir une **relation client humaine** et disponible donc nous serons toujours disponible que ce soit par mail ou t\xE9l\xE9phone pour vos questions ou vos nouveaux projets digitaux. On est l\xE0 depuis 2001 et on ne compte pas dispara\xEEtre de si t\xF4t.\nQue vous soyez d\xE9j\xE0 conquis ou encore perplexe n\u2019h\xE9sitez pas \xE0 nous contacter par t\xE9l\xE9phone, mail, chat ou carte postale, nous serons heureux de discuter avec vous de votre **communication num\xE9rique** ou tout autre projet informatique. **On vous attend !**\n';
	var technos = ['React', 'Gatsby', 'Javascript'];
	var IndexPage = function IndexPage(props) {
	  var previewProjects = props.data.previewProjects;
	
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(_reactHelmet2.default, {
	      meta: [{
	        name: 'description',
	        content: 'Création de sites internet, site vitrine, blog et portfolio de qualité premium.'
	      }]
	    }),
	    _react2.default.createElement(
	      _View2.default,
	      { colorMode: '2' },
	      _react2.default.createElement(_ServiceView2.default, {
	        picture: _picture_showcase2.default,
	        title: title,
	        description: description,
	        technologies: technos
	      }),
	      _react2.default.createElement(_IndexSecondView2.default, { data: previewProjects }),
	      _react2.default.createElement(_ContactView2.default, null),
	      _react2.default.createElement(_FooterView2.default, null)
	    )
	  );
	};
	
	exports.default = IndexPage;
	var query = exports.query = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-sites-vitrine-jsx-6217211e35c0045daa10.js